import Swiper from "swiper";
import { Pagination } from "swiper/modules";

const factoresData = {
    menopausia: {
        title: "Menopausia",
        text: "La mayor condición de riesgo es la menopausia. En España, la edad media de presentación de la menopausia es a los 50 años, mientras que la esperanza de vida ha aumentado hasta superar los 80 años. Esto condiciona que la mujer pase más de la tercera parte de su vida en menopausia. Esto ha generado que haya aumentado la prevalencia de Osteoporosis.",
        link: "#menopausia",
    },
    calcio: {
        title: "Déficit de Calcio",
        text: `El calcio es el principal componente mineral del hueso, por lo que es muy importante introducir el consumo de calcio en la dieta para un metabolismo óseo adecuado. El adulto sano con baja ingesta de calcio tiene incrementada la pérdida de masa ósea.<br><br>El consumo de calcio influye y es importante a todas las edades, en la infancia y adolescencia es fundamental para desarrollar una buena base de masa ósea; en la vida adulta ayuda a mantener el equilibrio adecuado entre la formación y la reabsorción del hueso; y en las edades más avanzadas ayuda a reducir la pérdida ósea y disminuye el riesgo de fracturas (sobre todo si es combinada con vitamina D, si el médico ha considerado un aporte adicional). Además, es importante incluir en la alimentación proteínas para desarrollar la masa muscular y la matriz ósea.`,
        link: "#calcio",
    },
    "estilo-de-vida": {
        title: "Estilo de vida",
        text: `Se ha demostrado que es fundamental tener un estilo de vida saludable para conservar la masa ósea. Tener una dieta equilibrada, hacer ejercicio de manera regular y evitar el consumo de alcohol y de tabaco ayuda a conserva una buena masa ósea y previene de padecer osteoporosis.<br><br>El consumo de alcohol se ha demostrado que tiene un impacto negativo sobre los huesos. En concreto, el alcohol provoca una disminución en la absorción de Calcio, aumenta el riesgo de caídas y afecta al metabolismo de la vitamina D. Un consumo elevado de alcohol produce una mayor pérdida de masa ósea, aumentando de manera significativa el riesgo de fracturas.<br><br>Otro factor a tener en cuenta es el consumo de tabaco, el cual aumenta el riesgo de sufrir osteoporosis. El tabaco reduce la absorción de calcio, acelera la menopausia o disminuye los niveles de estrógenos, entre muchos de sus efectos. Provocando una menor densidad ósea, un mayor riesgo de fracturas y una peor recuperación de las fracturas.<br><br>El sedentarismo provoca una pérdida de masa muscular, un menor estimulo óseo y un mayor riesgo de caídas. Por tanto, es muy importante realizar ejercicio de manera diaria para ayudar a fortalecer los huesos y evitar fracturas. Se deben evitar los reposos muy prolongados y deben incluirse ejercicios como caminar, entrenamiento de equilibrio o de fuerza para evitar la pérdida de masa muscular. Hay que tener en cuenta que los músculos que se cargan son los que más se fortalecen, por lo que, a mayor masa muscular, mayor estímulo óseo.`,
        link: "#estilo-de-vida",
    },
    edad: {
        title: "Edad",
        text: "La edad es uno de los factores de riesgo más importantes para la Osteoporosis. El hueso es un tejido que se renueva constantemente mediante la formación y la reabsorción óseas (la pérdida de tejido óseo). Hasta los 30 años, la formación supera a la reabsorción, por lo que tenemos nuestro pico de masa ósea. A partir de esa edad, la reabsorción comienza a superar a la formación, lo que provoca una disminución en la masa ósea de manera gradual. Con el envejecimiento, aumenta la fragilidad de nuestros huesos. En el hombre la edad es un factor de riesgo más específico que en mujeres. De hecho, en edades por encima de los 75 años tiende a igualarse la proporción mujer/hombre con Osteoporosis, llegando a ser 2:1.",
        link: "#edad",
    },
};

// const titleElement = document.getElementById("factor-content-title");
const textElement = document.getElementById("factor-content-text");
const linkElement = document.getElementById("factor-content-link");

function updateContent(factorKey) {
    const data = factoresData[factorKey];
    if (!data || !textElement || !linkElement) return;

    const contentContainer = document.querySelector(".factor-content");
    if (contentContainer) {
        contentContainer.style.opacity = "0";
    }

    window.setTimeout(() => {
        // titleElement.textContent = data.title;
        textElement.innerHTML = data.text;
        linkElement.href = data.link;

        if (contentContainer) {
            contentContainer.style.opacity = "1";
        }
    }, 150);
}

function setActiveItem(activeKey) {
    const items = document.querySelectorAll(".factor-item");
    items.forEach((item) => {
        const isActive = item.getAttribute("data-factor") === activeKey;
        item.classList.toggle("active", isActive);

        const icon = item.querySelector("svg");
        if (icon) {
            if (isActive) {
                icon.classList.remove("text-kefcare-primary-500");
                icon.classList.add("text-kefcare-tertiary-500");
            } else {
                icon.classList.remove("text-kefcare-tertiary-500");
                icon.classList.add("text-kefcare-primary-500");
            }
        }
    });
}

function initDesktop() {
    const factorItems = document.querySelectorAll(".factor-item");

    factorItems.forEach((item) => {
        item.addEventListener("click", () => {
            const factorKey = item.getAttribute("data-factor");
            updateContent(factorKey);
            setActiveItem(factorKey);
        });
    });
}

function initMobileSwiper() {
    const swiperContainer = document.querySelector(".factores-swiper");
    if (!swiperContainer) return null;

    return new Swiper(".factores-swiper", {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
        grabCursor: true,
        loop: false,
        initialSlide: 0,
        watchOverflow: true,
        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
        },
        on: {
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                if (!activeSlide) return;

                const factorKey = activeSlide.getAttribute("data-factor");
                updateContent(factorKey);

                this.slides.forEach((slide, index) => {
                    const icon = slide.querySelector("svg");
                    if (!icon) return;

                    if (index === this.activeIndex) {
                        icon.classList.remove("text-kefcare-primary-500");
                        icon.classList.add("text-kefcare-tertiary-500");
                    } else {
                        icon.classList.remove("text-kefcare-tertiary-500");
                        icon.classList.add("text-kefcare-primary-500");
                    }
                });
            },
        },
    });
}

function initConsejosSwiper() {
    const swiperContainer = document.querySelector(".consejos-swiper");
    if (!swiperContainer) return null;

    return new Swiper(".consejos-swiper", {
        modules: [Pagination],
        slidesPerView: 1.3,
        spaceBetween: 30,
        slidesOffsetBefore: 24,
        centeredSlides: false,
        grabCursor: true,
        loop: false,
        watchOverflow: true,
        pagination: {
            el: ".consejos-pagination",
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 1.5,
                spaceBetween: 40,
                slidesOffsetBefore: 40,
            },
            1024: {
                slidesPerView: 2.3,
                spaceBetween: 50,
                slidesOffsetBefore: 80,
            },
            1280: {
                slidesPerView: 2.3,
                spaceBetween: 60,
                slidesOffsetBefore: Math.max(
                    80,
                    (window.innerWidth - 1280) / 2 + 80,
                ),
            },
        },
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const contentContainer = document.querySelector(".factor-content");
    if (contentContainer) {
        contentContainer.style.transition = "opacity 0.15s ease-in-out";
    }

    updateContent("menopausia");
    initDesktop();
    setActiveItem("menopausia");
    initMobileSwiper();
    initConsejosSwiper();

    const firstMobileIcon = document.querySelector(
        '.factores-swiper .swiper-slide[data-factor="menopausia"] svg',
    );
    if (firstMobileIcon) {
        firstMobileIcon.classList.remove("text-kefcare-primary-500");
        firstMobileIcon.classList.add("text-kefcare-tertiary-500");
    }
});
